export const ROUTE_PATHS = {
  HOME: '/',
  LOGIN: '/login',
  SETUP: '/setup',
  ACTIVATION: '/activation',
  LICENSES: '/licenses',
  LICENSE: '/licenses/:licenseId',
  SEAT_USAGE: '/licenses/:licenseId/seat-usage',
  SEAT_SESSIONS: '/seat-sessions',
  ACTIVITY: '/activity',
  OFFLINE_USAGE: '/offline-usage',
  SETTINGS: '/settings',
  NOT_FOUND: '*'
} as const;

export type RoutePaths = typeof ROUTE_PATHS[keyof typeof ROUTE_PATHS];

/**
 * What each page of the menu is called wherever a person reads it: the menu, the title bar of a
 * narrow screen, the certificate banner's button. A path is a name for the browser and some read
 * differently: the Enrollment page lives at `/activation`, which the title bar used to show.
 */
export const PAGE_TITLES = {
  [ROUTE_PATHS.ACTIVATION]: 'Enrollment',
  [ROUTE_PATHS.LICENSES]: 'Licenses',
  [ROUTE_PATHS.SEAT_SESSIONS]: 'Seat sessions',
  [ROUTE_PATHS.ACTIVITY]: 'Activity',
  [ROUTE_PATHS.OFFLINE_USAGE]: 'Offline usage',
  [ROUTE_PATHS.SETTINGS]: 'Settings'
} as const;
